// INTERGROWTH-21st Newborn Size References for Very Preterm Infants — Birthweight
// Source: Villar J, Giuliani F, Fenton TR, Ohuma EO, Ismail LC, Kennedy SH et al.
// INTERGROWTH-21st very preterm size at birth reference charts. Lancet 2016,
// 387(10021):844-45. Tables reproduced from the official published PDFs:
// https://intergrowth21.com/tools-resources/newborn-size-very-preterm-infants
// (grow_verypreterm-ct-boys_bw_table.pdf / grow_verypreterm-ct-girls_bw_table.pdf,
// retrieved 2026-09, "Updated: 17th July 2026").
//
// Each row is birthweight in kg at the 3rd, 5th, 10th, 50th, 90th, 95th and 97th
// centiles, for one gestational age in completed weeks+days, covering 24+0 to
// 32+6 weeks — the full range these very-preterm reference charts publish.
// "Centiles below 28 weeks should be interpreted with caution given the small
// sample size" per the source tables.

export const IG_VP_CENTILE_POINTS = [3, 5, 10, 50, 90, 95, 97];

export const IG_VP_MIN_WEEKS = 24;
export const IG_VP_MAX_WEEKS = 32;

// Index 0 = 24+0, index 1 = 24+1, ... index 62 = 32+6
export const IG_VP_BOYS_KG = [
  [0.44,0.46,0.50,0.64,0.82,0.88,0.92],[0.45,0.47,0.51,0.65,0.83,0.89,0.93],
  [0.46,0.48,0.52,0.66,0.85,0.91,0.95],[0.47,0.49,0.53,0.68,0.87,0.93,0.97],
  [0.48,0.50,0.54,0.69,0.88,0.95,0.99],[0.49,0.51,0.55,0.70,0.90,0.96,1.01],
  [0.50,0.52,0.56,0.72,0.92,0.98,1.03],
  [0.51,0.53,0.57,0.73,0.93,1.00,1.05],[0.52,0.54,0.58,0.74,0.95,1.02,1.07],
  [0.53,0.55,0.59,0.76,0.97,1.04,1.09],[0.54,0.56,0.60,0.77,0.99,1.06,1.11],
  [0.55,0.57,0.61,0.79,1.01,1.08,1.13],[0.56,0.58,0.63,0.80,1.03,1.10,1.15],
  [0.57,0.59,0.64,0.82,1.04,1.12,1.17],
  [0.58,0.60,0.65,0.83,1.06,1.14,1.20],[0.59,0.62,0.66,0.85,1.08,1.16,1.22],
  [0.60,0.63,0.67,0.86,1.10,1.19,1.24],[0.61,0.64,0.69,0.88,1.13,1.21,1.26],
  [0.62,0.65,0.70,0.89,1.15,1.23,1.29],[0.63,0.66,0.71,0.91,1.17,1.25,1.31],
  [0.65,0.68,0.72,0.93,1.19,1.28,1.33],
  [0.66,0.69,0.74,0.95,1.21,1.30,1.36],[0.67,0.70,0.75,0.96,1.23,1.32,1.38],
  [0.68,0.71,0.77,0.98,1.26,1.35,1.41],[0.69,0.73,0.78,1.00,1.28,1.37,1.44],
  [0.71,0.74,0.79,1.02,1.30,1.40,1.46],[0.72,0.75,0.81,1.03,1.33,1.42,1.49],
  [0.73,0.77,0.82,1.05,1.35,1.45,1.52],
  [0.75,0.78,0.84,1.07,1.37,1.47,1.54],[0.76,0.79,0.85,1.09,1.40,1.50,1.57],
  [0.77,0.81,0.87,1.11,1.42,1.53,1.60],[0.79,0.82,0.88,1.13,1.45,1.56,1.63],
  [0.80,0.84,0.90,1.15,1.48,1.58,1.66],[0.82,0.85,0.92,1.17,1.50,1.61,1.69],
  [0.83,0.87,0.93,1.19,1.53,1.64,1.72],
  [0.84,0.88,0.95,1.21,1.56,1.67,1.75],[0.86,0.90,0.97,1.24,1.58,1.70,1.78],
  [0.87,0.92,0.98,1.26,1.61,1.73,1.81],[0.89,0.93,1.00,1.28,1.64,1.76,1.84],
  [0.91,0.95,1.02,1.30,1.67,1.79,1.87],[0.92,0.96,1.03,1.33,1.70,1.82,1.91],
  [0.94,0.98,1.05,1.35,1.73,1.85,1.94],
  [0.95,1.00,1.07,1.37,1.76,1.89,1.97],[0.97,1.02,1.09,1.40,1.79,1.92,2.01],
  [0.99,1.03,1.11,1.42,1.82,1.95,2.04],[1.00,1.05,1.13,1.45,1.85,1.99,2.08],
  [1.02,1.07,1.15,1.47,1.88,2.02,2.11],[1.04,1.09,1.17,1.50,1.92,2.05,2.15],
  [1.06,1.11,1.19,1.52,1.95,2.09,2.19],
  [1.08,1.13,1.21,1.55,1.98,2.13,2.23],[1.09,1.15,1.23,1.57,2.02,2.16,2.26],
  [1.11,1.16,1.25,1.60,2.05,2.20,2.30],[1.13,1.18,1.27,1.63,2.09,2.24,2.34],
  [1.15,1.21,1.29,1.66,2.12,2.28,2.38],[1.17,1.23,1.31,1.68,2.16,2.31,2.42],
  [1.19,1.25,1.34,1.71,2.19,2.35,2.46],
  [1.21,1.27,1.36,1.74,2.23,2.39,2.50],[1.23,1.29,1.38,1.77,2.27,2.43,2.55],
  [1.25,1.31,1.41,1.80,2.31,2.47,2.59],[1.27,1.33,1.43,1.83,2.35,2.52,2.63],
  [1.29,1.35,1.45,1.86,2.38,2.56,2.68],[1.32,1.38,1.48,1.89,2.42,2.60,2.72],
  [1.34,1.40,1.50,1.92,2.46,2.64,2.77],
];

export const IG_VP_GIRLS_KG = [
  [0.42,0.44,0.47,0.60,0.77,0.83,0.87],[0.43,0.45,0.48,0.61,0.79,0.84,0.88],
  [0.44,0.46,0.49,0.63,0.80,0.86,0.90],[0.44,0.46,0.50,0.64,0.82,0.88,0.92],
  [0.45,0.47,0.51,0.65,0.83,0.89,0.94],[0.46,0.48,0.52,0.66,0.85,0.91,0.95],
  [0.47,0.49,0.53,0.68,0.87,0.93,0.97],
  [0.48,0.50,0.54,0.69,0.88,0.95,0.99],[0.49,0.51,0.55,0.70,0.90,0.96,1.01],
  [0.50,0.52,0.56,0.71,0.92,0.98,1.03],[0.51,0.53,0.57,0.73,0.93,1.00,1.05],
  [0.52,0.54,0.58,0.74,0.95,1.02,1.07],[0.53,0.55,0.59,0.76,0.97,1.04,1.09],
  [0.54,0.56,0.60,0.77,0.99,1.06,1.11],
  [0.55,0.57,0.61,0.78,1.01,1.08,1.13],[0.56,0.58,0.62,0.80,1.02,1.10,1.15],
  [0.57,0.59,0.64,0.81,1.04,1.12,1.17],[0.58,0.60,0.65,0.83,1.06,1.14,1.19],
  [0.59,0.62,0.66,0.85,1.08,1.16,1.22],[0.60,0.63,0.67,0.86,1.10,1.18,1.24],
  [0.61,0.64,0.68,0.88,1.12,1.20,1.26],
  [0.62,0.65,0.70,0.89,1.14,1.23,1.28],[0.63,0.66,0.71,0.91,1.16,1.25,1.31],
  [0.64,0.67,0.72,0.93,1.19,1.27,1.33],[0.66,0.69,0.74,0.94,1.21,1.30,1.36],
  [0.67,0.70,0.75,0.96,1.23,1.32,1.38],[0.68,0.71,0.76,0.98,1.25,1.34,1.41],
  [0.69,0.72,0.78,1.00,1.27,1.37,1.43],
  [0.70,0.74,0.79,1.01,1.30,1.39,1.46],[0.72,0.75,0.81,1.03,1.32,1.42,1.48],
  [0.73,0.76,0.82,1.05,1.34,1.44,1.51],[0.74,0.78,0.83,1.07,1.37,1.47,1.54],
  [0.76,0.79,0.85,1.09,1.39,1.49,1.56],[0.77,0.81,0.86,1.11,1.42,1.52,1.59],
  [0.78,0.82,0.88,1.13,1.44,1.55,1.62],
  [0.80,0.83,0.90,1.15,1.47,1.58,1.65],[0.81,0.85,0.91,1.17,1.50,1.60,1.68],
  [0.83,0.86,0.93,1.19,1.52,1.63,1.71],[0.84,0.88,0.94,1.21,1.55,1.66,1.74],
  [0.86,0.90,0.96,1.23,1.58,1.69,1.77],[0.87,0.91,0.98,1.25,1.60,1.72,1.80],
  [0.89,0.93,0.99,1.27,1.63,1.75,1.83],
  [0.90,0.94,1.01,1.30,1.66,1.78,1.86],[0.92,0.96,1.03,1.32,1.69,1.81,1.90],
  [0.93,0.98,1.05,1.34,1.72,1.84,1.93],[0.95,0.99,1.07,1.36,1.75,1.88,1.96],
  [0.97,1.01,1.08,1.39,1.78,1.91,2.00],[0.98,1.03,1.10,1.41,1.81,1.94,2.03],
  [1.00,1.05,1.12,1.44,1.84,1.97,2.07],
  [1.02,1.06,1.14,1.46,1.87,2.01,2.10],[1.03,1.08,1.16,1.49,1.90,2.04,2.14],
  [1.05,1.10,1.18,1.51,1.94,2.08,2.17],[1.07,1.12,1.20,1.54,1.97,2.11,2.21],
  [1.09,1.14,1.22,1.56,2.00,2.15,2.25],[1.11,1.16,1.24,1.59,2.04,2.19,2.29],
  [1.12,1.18,1.26,1.62,2.07,2.22,2.33],
  [1.14,1.20,1.28,1.64,2.11,2.26,2.37],[1.16,1.22,1.31,1.67,2.14,2.30,2.40],
  [1.18,1.24,1.33,1.70,2.18,2.34,2.45],[1.20,1.26,1.35,1.73,2.21,2.38,2.49],
  [1.22,1.28,1.37,1.76,2.25,2.42,2.53],[1.24,1.30,1.40,1.79,2.29,2.46,2.57],
  [1.26,1.32,1.42,1.82,2.33,2.50,2.61],
];

/**
 * Classify a birthweight against the INTERGROWTH-21st Very Preterm standard
 * using ONLY the exact published table values — no interpolation, no
 * synthesized decimal. Returns which bracket the weight falls into, using
 * the real numbers from the official table, plus the full reference row so
 * it can be shown alongside for verification.
 *
 * @param {number} weightKg  birthweight in kilograms
 * @param {number} weeks     completed gestational weeks (24-32)
 * @param {number} days      completed gestational days within that week (0-6)
 * @param {"Male"|"Female"} sex
 * @returns {{
 *   lowerPoint: number,      // nearest published centile the weight meets/exceeds (0, 3, 5, 10, 50, 90, 95, or 97)
 *   label: string,           // e.g. "10th\u201350th centile" or "<3rd centile" or ">97th centile"
 *   row: number[],           // the exact 7 published values [c3,c5,c10,c50,c90,c95,c97] for this GA+sex, in kg
 * } | null} null if GA/sex is outside what this chart covers.
 */
export function classifyVeryPretermCentile(weightKg, weeks, days, sex) {
  if (!Number.isFinite(weightKg) || weightKg <= 0) return null;
  if (sex !== "Male" && sex !== "Female") return null;
  if (!Number.isInteger(weeks) || !Number.isInteger(days)) return null;
  if (weeks < IG_VP_MIN_WEEKS || weeks > IG_VP_MAX_WEEKS) return null;
  if (weeks === IG_VP_MAX_WEEKS && days > 6) return null;

  const idx = (weeks - IG_VP_MIN_WEEKS) * 7 + days;
  const table = sex === "Male" ? IG_VP_BOYS_KG : IG_VP_GIRLS_KG;
  const row = table[idx];
  if (!row) return null;

  if (weightKg < row[0]) return { lowerPoint: 0, label: "<3rd centile", row };
  for (let i = IG_VP_CENTILE_POINTS.length - 1; i >= 0; i--) {
    if (weightKg >= row[i]) {
      const isLast = i === IG_VP_CENTILE_POINTS.length - 1;
      const label = isLast
        ? `>${IG_VP_CENTILE_POINTS[i]}th centile`
        : `${IG_VP_CENTILE_POINTS[i]}th\u2013${IG_VP_CENTILE_POINTS[i + 1]}th centile`;
      return { lowerPoint: IG_VP_CENTILE_POINTS[i], label, row };
    }
  }
  return { lowerPoint: 0, label: "<3rd centile", row };
}